// just a stub to require the right date.js source file to behave the same as
// the old minified version
import 'vendor/date-js/parser'
